import React, { useState, useRef } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Link } from 'react-router-dom';

import './loans.css';


const BorrowerNamesInGrid = ( { row, contacts } ) => {
    const borrowers = row.borrowers || [];
    const pri = borrowers?.find( b => b.label === 'Primary' );

    const [show, setShow] = useState(false);
    const handleOnMouseEnter = () => {
        setShow( true );
    }
    const handleOnMouseLeave = () => {
        setShow( false );
    }

    const formatName = ( cid ) => {
        const c = contacts[cid]; // .find( con => con.cid === cid );
        if ( !c ) {
            return null;
        }
        let n = c.firstname;
        if ( c.namePreferred && c.namePreferred.length ) {
            n = c.namePreferred;
        }
        if ( c.lastname && c.lastname.length ) {
            n += ' ' + c.lastname;
        }
        
        return n.trim();
    };

    const ref = useRef();

    const popup = (
        <Popover id="popover-basic" style={ { width: '300px', zIndex: '9999' } } onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <Popover.Header as="h3">Borrowers</Popover.Header>
            <Popover.Body>
                { 
                    borrowers?.map( ( b, idx ) => {
                        return (
                            <Row key={`${b?.cid}-${idx}`} className='text-start py-1' style={ { fontSize: '12px' } }>
                                <Col xs={5} className='pe-1 fw-bold'>{b?.label}</Col>
                                <Col className='ps-0'><Link to={`/contact/${b?.cid}`}>{formatName( b?.cid )}</Link></Col>
                            </Row>
                        )
                    } ) 
                }
            </Popover.Body>
        </Popover>
    );

    return (
        <Container>
            <Row className='p-0'>
                <Col xs='auto' className='p-0 pe-2'><Link to={`/contact/${pri?.cid}`}>{formatName( pri?.cid )}</Link></Col>
                {
                    borrowers.length > 1
                    &&  <OverlayTrigger placement="right" overlay={popup} show={show} container={ref}>
                            <Col xs='auto' className='tf-multi-borrower-badge ps-1 align-items-center' ref={ref} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>+{borrowers.length - 1}</Col>
                        </OverlayTrigger>
                }
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    contacts: state.contacts.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.loans.loadActives
} );
  
export default connect( mapProps, mapDispatch )( BorrowerNamesInGrid );